function eikaAccordion(): void {
    function toggleAccordion(e: MouseEvent): void {
        const currElement = e.currentTarget as HTMLButtonElement;
        const panel = document.getElementById(currElement.getAttribute('aria-controls')!);
        const container = currElement.closest('.sgw-expand-list-card')! as HTMLElement;

        if (panel && container) {
            const isExpanded = currElement.getAttribute('aria-expanded') === 'true';
            const arrowIcon = currElement.querySelector('.sgw-expand-list-card__arrow') as HTMLSpanElement;
            if (isExpanded) {
                panel!.style.maxHeight = '0px';
                container.classList.remove('expanded');
                arrowIcon.classList.remove('active');
            } else {
                panel!.style.maxHeight = `${panel!.scrollHeight}px`;
                container.classList.add('expanded');
                arrowIcon.classList.add('active');
            }
            currElement.setAttribute('aria-expanded', (!isExpanded).toString());
            panel.toggleAttribute('inert');
        }
    }

    const initAccordion = (): void => {
        const accordionTriggers = document.querySelectorAll<HTMLButtonElement>('.sgw-expand-list-card__header');
        if (accordionTriggers) {
            accordionTriggers.forEach((trigger) => {
                trigger.addEventListener('click', toggleAccordion);
                // experience editor default open
                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                    const container = trigger.closest('.sgw-expand-list-card')! as HTMLElement;
                    const arrowIcon = container.querySelector('.sgw-expand-list-card__arrow') as HTMLSpanElement;
                    arrowIcon.classList.add('active');
                }
            });
        }
    };

    document.addEventListener('DOMContentLoaded', initAccordion);
}

export default eikaAccordion;
